/* eslint no-console:0 */
import "../stylesheets/application.scss"
import 'bootstrap/dist/js/bootstrap'
import '../src/make-mail-form.js'
import '../src/user-form.js'

import Rails from '@rails/ujs';

Rails.start()
